import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchIcon } from "@heroicons/react/solid";

import { NO_ACCESS_TYPES, PERMISSIONS } from "../../utils/constants";

import Button from "../SharedComponents/Button";
import AccessControl from "../SharedComponents/AccessControl";
import Tippy from "@tippyjs/react";

function Search() {
    const searchTerm = useRef(null);

    const [searchArea, setSearchArea] = useState("");
    const [showFilterTooltip, setShowFilterTooltip] = useState(false);

    const navigate = useNavigate();

    const handleSearch = () => {
        switch (searchArea) {
            case "reports":
                navigate("/reports/" + searchTerm.current.value);
                break;
            case "userGroups":
                navigate("/user-groups/" + searchTerm.current.value);
                break;
            case "users":
                navigate("/users/" + searchTerm.current.value);
                break;
            default:
                setShowFilterTooltip(true);
                break;
        }
    };

    const handleKeyPress = (key) => {
        if (key.code === "Enter") {
            handleSearch();
        }
    };

    return (
        <AccessControl requiredPermission={PERMISSIONS.SEARCH} noAccessType={NO_ACCESS_TYPES.BLANK}>
            <div
                className={
                    "flex flex-row justify-between items-center gap-6 w-full py-1.5 px-2.5 " +
                    "shadow-sm bg-white rounded-lg z-30"
                }
            >
                <div
                    className={
                        "flex-grow flex items-center w-full rounded-md border-gray-200 focus:border-primary-600 " +
                        "focus:border-transparent"
                    }
                >
                    <SearchIcon className="block h-5 w-5 mr-2" />
                    <input
                        ref={searchTerm}
                        onKeyPress={handleKeyPress}
                        type="text"
                        name="search"
                        id="globalSearch"
                        placeholder="Search users, user groups and reports. E.g. 'Careering Ahead'"
                        className={
                            "text-sm rounded-md p-2 w-full focus:outline-none focus:border-none focus:ring-0" +
                            "text-indigo-900 outline-none border-none shadow-none ring-0 ring-transparent focus:ring-0"
                        }
                    />
                </div>
                <div className={"flex-grow lg:block hidden"}>
                    <Tippy
                        content={"Please choose a filter"}
                        className={"p-2 shadow rounded-md bg-primary-100 text-primary-700 text-sm"}
                        arrow={false}
                        animation={"shift-away-subtle"}
                        placement={"top"}
                        disabled={!showFilterTooltip}
                        showOnCreate={true}
                    >
                        <div className="flex flex-row gap-4 lg:justify-end 2xl:justify-end items-center h-full text-sm">
                            <div className="flex items-center justify-center md:justify-start">
                                <input
                                    id="users"
                                    type="radio"
                                    name="searchArea"
                                    onChange={(e) => setSearchArea(e.target.id)}
                                    className={
                                        "h-3.5 w-3.5 focus:ring-0 focus:ring-transparent focus:outline-0 " +
                                        "focus:shadow-none focus:outline-none transition-colors"
                                    }
                                />
                                <label htmlFor="reports" className="ml-2 text-primary-900">
                                    Users
                                </label>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <input
                                    id="userGroups"
                                    type="radio"
                                    name="searchArea"
                                    onChange={(e) => setSearchArea(e.target.id)}
                                    className={
                                        "h-3.5 w-3.5 focus:ring-0 focus:ring-transparent focus:outline-0 " +
                                        "focus:shadow-none focus:outline-none transition-colors"
                                    }
                                />
                                <label htmlFor="reports" className="ml-2 text-primary-900 w-max">
                                    User groups
                                </label>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <input
                                    id="reports"
                                    type="radio"
                                    name="searchArea"
                                    onChange={(e) => setSearchArea(e.target.id)}
                                    className={
                                        "h-3.5 w-3.5 focus:ring-0 focus:ring-transparent focus:outline-0 " +
                                        "focus:shadow-none focus:outline-none transition-colors"
                                    }
                                />
                                <label htmlFor="reports" className="ml-2 text-primary-900">
                                    Reports
                                </label>
                            </div>
                        </div>
                    </Tippy>
                </div>
                <Button
                    onClick={handleSearch}
                    text="Search"
                    extraStyling={
                        "text-white focus:ring-inset focus:ring-1 bg-primary-600 hover:bg-primary-700 " +
                        "focus:outline-none focus:ring-primary-600 hidden lg:flex"
                    }
                />
            </div>
        </AccessControl>
    );
}

export default Search;
